import { MantineProvider, MantineThemeOverride } from "@mantine/core";
import { NotificationsProvider } from "@mantine/notifications";
import { createTheme, ThemeProvider } from "@mui/material";
import { PostHogProvider } from "posthog-js/react";
import React from "react";
import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { RecoilRoot } from "recoil";

import { App } from "./app";
import { PlayerProvider } from "./contexts/Player/PlayerContext";
import RecoilNexus from "./contexts/RecoilNexus";
import { theme } from "./mantine.config";
import * as serviceWorker from "./serviceWorker";

const router = createBrowserRouter(
  createRoutesFromElements(<Route path="/*" element={<App />} />)
);

const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");
const root = createRoot(container);

root.render(
  <PostHogProvider
    apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
    options={{
      api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
      defaults: "2025-05-24",
      capture_exceptions: true, // This enables capturing exceptions using Error Tracking
      debug: import.meta.env.MODE === "development",
    }}
  >
    <RecoilRoot>
      <RecoilNexus />
      <MantineProvider theme={theme as MantineThemeOverride}>
        <ThemeProvider theme={createTheme({})}>
          <NotificationsProvider position="top-center">
            <PlayerProvider>
              <RouterProvider router={router} />
            </PlayerProvider>
          </NotificationsProvider>
        </ThemeProvider>
      </MantineProvider>
    </RecoilRoot>
  </PostHogProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
